import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const Result = React.forwardRef((_a, ref) => {
    var { className, icon, title, subtitle, children } = _a, props = __rest(_a, ["className", "icon", "title", "subtitle", "children"]);
    return (React.createElement("div", Object.assign({ className: clsx(className, 'result'), ref: ref }, props),
        icon && React.createElement("div", { className: 'result__icon' }, icon),
        title && React.createElement("div", { className: 'result__title' }, title),
        subtitle && React.createElement("div", { className: 'result__subtitle' }, subtitle),
        children && React.createElement("div", { className: 'result__extra' }, children)));
});
Result.displayName = 'Result';
export { Result };
//# sourceMappingURL=Result.js.map